export const RU = 'ru'
export const EN = 'en'
